export default __webpack_public_path__ + "static/media/89_desktop.aaa8b22f.jpg";